import { END_POINT } from "../constants";
import { HTTP } from "./http";

export const ContactService = {
  sendForm: (data) => {
    return HTTP.post(`https://n26c2ss4l4.execute-api.us-west-2.amazonaws.com/default/sendcontact`, data);
  },
}